export function assignSealed(target, src) {
    Object.keys(src).forEach((key) => {
        Object.defineProperty(target, key, {
            writable: true,
            enumerable: true,
            configurable: false,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            value: src[key],
        });
    });
}
//# sourceMappingURL=assignSealed.js.map